import axiosHandler from "interceptor/axiosInterceptor";

// Challenges
export const getChallenges = async (params) => {
  try {
    const response = await axiosHandler.get("/api/admin/challenges", { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getChallengeById = async (id) => {
  try {
    const response = await axiosHandler.get(`/api/admin/challenges/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createChallenge = async (data) => {
  try {
    const response = await axiosHandler.post("/api/admin/challenges", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateChallenge = async (id, data) => {
  try {
    const response = await axiosHandler.put(`/api/admin/challenges/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const toggleChallengeStatus = async (id, is_active) => {
  try {
    const response = await axiosHandler.patch(`/api/admin/challenges/${id}/status`, { is_active });
    return response;
  } catch (error) {
    throw error;
  }
};

// Sports
export const getSports = async (params) => {
  try {
    const response = await axiosHandler.get("/api/admin/sports", { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSportById = async (id) => {
  try {
    const response = await axiosHandler.get(`/api/admin/sports/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createSport = async (data) => {
  try {
    const response = await axiosHandler.post("/api/admin/sports", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateSport = async (id, data) => {
  try {
    const response = await axiosHandler.put(`/api/admin/sports/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const toggleSportStatus = async (id, is_active) => {
  try {
    const response = await axiosHandler.patch(`/api/admin/sports/${id}/status`, { is_active });
    return response;
  } catch (error) {
    throw error;
  }
};

// Highlights
export const getHighlights = async (params) => {
  try {
    const response = await axiosHandler.get("/api/admin/highlights", { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateHighlightStatus = async (id, status) => {
  try {
    const response = await axiosHandler.patch(`/api/admin/highlights/${id}/status`, { status });
    return response;
  } catch (error) {
    throw error;
  }
};

// FAQs
export const getFAQs = async (params) => {
  try {
    const response = await axiosHandler.get("/api/admin/faqs", { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getFAQById = async (id) => {
  try {
    const response = await axiosHandler.get(`/api/admin/faqs/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createFAQ = async (data) => {
  try {
    const response = await axiosHandler.post("/api/admin/faqs", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateFAQ = async (id, data) => {
  try {
    const response = await axiosHandler.put(`/api/admin/faqs/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteFAQ = async (id) => {
  try {
    const response = await axiosHandler.delete(`/api/admin/faqs/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

// Support
export const getReportedIssues = async (params) => {
  try {
    const response = await axiosHandler.get("/api/admin/support/issues", { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateIssueStatus = async (id, status) => {
  try {
    const response = await axiosHandler.patch(`/api/admin/support/issues/${id}`, { status });
    return response;
  } catch (error) {
    throw error;
  }
};
